import { CustomLink } from '@/app/_components/CustomLink';
import { Image } from '@/components/client';

import type { MedianIncomeYear } from '../constants';
import { MEDIAN_INCOME_BY_YEAR } from '../constants';

interface RecommendedContentsProps {
  year: MedianIncomeYear;
}

/**
 * ⑧ 추천 콘텐츠 카드 — 가로형 (좌: 제목·요약, 우: 정사각형 썸네일).
 * 카드 전체가 CustomLink — 클릭 시 정책 활용 가이드 상세로 이동.
 */
export const RecommendedContents = ({ year }: RecommendedContentsProps) => {
  const { recommendedContents } = MEDIAN_INCOME_BY_YEAR[year];

  return (
    <section className="flex flex-col gap-12">
      <div className="flex items-baseline justify-between mobile-tablet:px-16">
        <h2 className="font-700 text-Gray-900 typo-h5 mobile-tablet:typo-h6">
          추천 콘텐츠
        </h2>
      </div>

      <div className="flex flex-col gap-12 mobile-tablet:px-16">
        {recommendedContents.map((content) => (
          <CustomLink
            key={content.url}
            href={content.url}
            className="flex items-stretch gap-16 rounded-medium border-1 border-Gray-100 bg-Gray-white p-16 transition-colors hover:border-B-300"
          >
            <div className="line-clamp-2 min-w-0 flex-1 font-700 text-Gray-900 typo-body3">
              {content.title}
            </div>
            <div className="relative size-96 shrink-0 overflow-hidden rounded-small bg-Gray-100">
              {content.thumbnail ? (
                <Image
                  src={content.thumbnail}
                  alt={content.title}
                  fill
                  className="object-cover"
                />
              ) : null}
            </div>
          </CustomLink>
        ))}
      </div>
    </section>
  );
};
